<template>
  <div class="c-button">
    <button
      v-if="type !== 'link'"
      :style="styles"
      class="c-button__button"
      :disabled="disabled"
      :class="{
        bg_red: bg_red,
        bg_white: bg_white,
        middle: middle,
        small: small,
        no_width: no_width,
        font_bold: font_bold,
        border_red: border_red,
        border_red_text_black: border_red_text_black,
        border_only_red: border_only_red,
        border_gray: border_gray,
        icon: icon,
        display: display,
        width: width,
        tablet_width: tablet_width,
        sp_width: sp_width,
        font_size: font_size,
        color_red_text: color_red_text
      }"
      @click="callback ? callback(attr[0]) : () => {}"
      :type=" submit_type ? 'submit': 'button' "
      >
        <img class="c-button__icon" v-if="icon" :src="require(`@/assets/images/${icon}.png`)" alt="">
        {{title}}
        <span class="c-button__label" v-if="label">{{label}}</span>
      </button>

      <a
        :href="link_url"
        v-if="type === 'link'"
        :style="styles"
        class="c-button__button"
        :disabled="disabled"
        :class="{
          bg_red: bg_red,
          bg_white: bg_white,
          middle: middle,
          small: small,
          no_width: no_width,
          font_bold: font_bold,
          border_red: border_red,
          border_red_text_black: border_red_text_black,
          border_only_red: border_only_red,
          border_gray: border_gray,
          icon: icon,
          display: display,
          width: width,
          tablet_width: tablet_width,
          sp_width: sp_width,
          font_size: font_size,
          color_red_text: color_red_text
        }"
        :target=" target_blank ? '_blank': '' "
        @click="callback(attr[0])"
        >
        <img class="c-button__icon" v-if="icon" :src="require(`@/assets/images/${icon}.png`)" alt="">
        {{title}}
        <span class="c-button__label" v-if="label">{{label}}</span>
      </a>
  </div>
</template>

<script>
export default {
  name: 'CommonButton',
  props: [
    'callback',
    'title',
    'bg_red',
    'bg_white',
    'middle',
    'small',
    'no_width',
    'border_red',
    'font_bold',
    'border_red_text_black',
    'border_only_red',
    'icon',
    'display',
    'type',
    'link_url',
    'border_gray',
    'font_size',
    'width',
    'sp_width',
    'submit_type',
    'target_blank',
    'attr',
    'tablet_width',
    'disabled',
    'label',
    'color_red_text',
  ],
  data() {
    return {};
  },
  mounted() {
  },
  computed: {
    styles() {
      return {
        '--font_size': this.font_size,
        '--width': this.width,
        '--sp_width': this.sp_width,
        '--display': this.display,
      };
    },
  },
};
</script>

<style lang='scss' scoped>
@charset 'UTF-8';
.c-button {
  position: relative;

  &__button {
    font-family:'メイリオ', 'Meiryo', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 352px;
    height: 55px;
    margin: 0 auto;
    border: 1px solid #707070;
    border-radius: 27px;
    transition: all .2s;
    font-size: 18px;

    &.bg_red {
      background-color:#E83532;
      border: 1px solid #E83532;
      color: #fff;
    }
    &.bg_red:hover {
      background-color:#fff;
      border-color: #E83532;
      color: #E83532;
    }
    &.bg_white {
      background-color:#fff;
      border: 1px solid #E83532;
      color: #E83532;
    }
    &.bg_white:hover {
      background-color:#E83532;
      border-color: #E83532;
      color: #fff;
    }
    &.middle {
      max-width: 304px;
      height: 39px !important;
    }
    &.small {
      min-width: 82px;
      height: 34px !important;
      font-size: 14px;
    }
    &.no_width {
      max-width: none;
      width: auto;
      padding: 0 14px;
      line-height: 1.2;
    }
    &.border_red {
      border-color: #E83532;
      color: #E83532;
    }
    &.border_red:hover {
      border-color: #fff;
      color: #fff;
      background-color:#E83532;
    }
    &.border_only_red {
      border-color: #E83532 !important;
    }
    &.border_gray {
      border: 1px solid #ccc;
    }
    &.font_bold {
      font-weight: bold;
    }
    &.border_red_text_black {
      border-color: #E83532;
      background-color: #fff;
    }
    &.border_red_text_black:hover {
      color: #fff;
      background-color: #E83532;
    }
    &.icon:hover {
      opacity: 0.7;
      background: none;
      color: #666;
    }
    &.inline {
      display: var(--display);
    }
    &.width {
      max-width: var(--width);
      width: var(--width);
    }
    &.font_size {
      font-size: var(--font_size);
    }
    &.color_red_text {
      color: #E83532;

      &:hover {
        color: #E83532;
      }
    }
  }
  &__button:hover {
    background-color:#707070;
    color:#fff;
  }
  &__icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    margin-right: 10px;
  }
  &__label {
    padding: 4px 10px;
    margin-left: 12px;
    border: 1px solid #E83532;
    border-radius: 20px;
    color: #E83532;
    font-size: 12px;
  }
}

@media screen and (max-width: 999px) {
  .c-button {
    &__button {
      &.tablet_width {
        width: 100%;
        max-width: 100%;
        padding: 0 20px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .c-button {
    &__button {
      &.width {
        width: 100%;
        max-width: 100%;
        padding: 0 20px;
      }
    }
  }
}
</style>
